import React from 'react';

class Titles extends React.Component {
    render(){
        return (
            <div>
                <h1 className='title-container__title'> Weather Fetcher </h1>
                <h3 className='title-container__subtitle'> Find out temperature, conditions, and more </h3>
            </div>
        );
    }
}

export default Titles;


// WEBPACK FOOTER //
// ./src/components/Titles.js